import { render, staticRenderFns } from "./post_table.vue?vue&type=template&id=23a52c88&scoped=true"
import script from "./post_table.vue?vue&type=script&lang=js"
export * from "./post_table.vue?vue&type=script&lang=js"
import style0 from "./post_table.vue?vue&type=style&index=0&id=23a52c88&prod&lang=css"
import style1 from "./post_table.vue?vue&type=style&index=1&id=23a52c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a52c88",
  null
  
)

export default component.exports